(() => {
  if (window.storePinchZoomBlocked) return;
  window.storePinchZoomBlocked = true;

  const cancelGesture = (event) => {
    if (event.cancelable) event.preventDefault();
  };
  const cancelMultiTouch = (event) => {
    if (event.touches.length > 1) cancelGesture(event);
  };

  // Safari exposes pinch gestures separately from standard touch events.
  document.addEventListener('gesturestart', cancelGesture, { passive: false });
  document.addEventListener('gesturechange', cancelGesture, { passive: false });
  document.addEventListener('touchstart', cancelMultiTouch, { passive: false, capture: true });
  document.addEventListener('touchmove', cancelMultiTouch, { passive: false, capture: true });
})();
